import { request } from '@/services/api/client';

import type { ModelCapabilityListResponse } from '../types';

export const modelCapabilityApi = {
  async listAll(): Promise<ModelCapabilityListResponse> {
    const response = await request<ModelCapabilityListResponse>('/canvas/model-capabilities');
    return response;
  },
};
